<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Reportes</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
  </v-toolbar>
  <v-card>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex d-flex>
            <v-select
               v-bind:readonly="disabledRegistro"
              :items="reportes"
              item-text="value"
              item-value="id"
              label="Tipo de reporte"
              v-model="registro.tipoReporte"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click.native="generar" v-if="!disabledRegistro">Generar</v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    disabledRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menuFechaInicio: false,
    menuFechaFin: false,
    fechaInicio: null,
    fechaFin: null,
    datos: [],
    reportes: [],
    registro: {}
  }),
  computed: {
  },
  created () {
    this.initialize()
    this.nuevoRegistro()
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.API}inicio.php?mod=reportes&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.reportes = datos.d.tipoReporte
            if (item.id !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({id: 0})
    },
    generar () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      var nombreReporte = 'Reporte'
      for (var reporte in this.reportes) {
        if (this.reportes[reporte].id === this.registro.tipoReporte) {
          nombreReporte = this.reportes[reporte].value
        }
      }
      const myRequest = new Request(`${process.env.API}reportes.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/xlsx'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.download = nombreReporte + '.xlsx'
          link.click()
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Reportes.vue